import {Component, Inject, Prop, Vue, Watch} from "vue-property-decorator";
import {AppSettings} from "~/lib/app-settings";
import {Getter} from "vuex-class";
import {getAllNotificationsForOwner, removeNotification} from "~/modules/notifications/service";
import {Notification} from "~/modules/notifications/lib/notification";
import {formatDate} from "~/lib/helpers/formatters";
import {Pagination, PaginationComponent} from "~/components/pagination";
import {Confirm} from "~/components/modals/confirm";
import {isDefined} from "~/lib/helpers/guards";

@Component
export class NotificationsList extends Vue {

  @Inject() appSettings: AppSettings;
  @Getter currentUser;

  protected isLoading:boolean = false;
  protected notifications:Notification[] = [];
  protected total: number =  0;
  protected pagination: Pagination = { offset: 0, limit: 100 };

  protected removeTarget:Notification = null;

  @Watch("pagination")
  async onPaginationChange(){
    await this.loadNotifications();
  }

  get notificationOwnerUUID() {
    return this.appSettings.clientUUID || this.currentUser.client;
  }

  async created(){
   await this.loadNotifications();
  }

  async loadNotifications() {
    this.isLoading = true;
    const {notifications, total} = await getAllNotificationsForOwner(this.notificationOwnerUUID, {
      sort: {key: "publicationDate", order: "DESC"},
      pagination: this.pagination
    });
    this.total = total;
    this.notifications = notifications;
    this.isLoading = false;
  }

  async remove(){
    await removeNotification(this.removeTarget);
    this.notifications = this.notifications.filter( item => item.uuid !== this.removeTarget.uuid );
    this.removeTarget = null;
  }

  render() {

    if( this.isLoading) return <p>Chargement</p>;
    if( this.notifications.length === 0 ) return <p>Aucune notification</p>;

    return (
      <div>
        <div>
          {this.notifications.map( notification => <NotificationListItem notification={notification} onRemoveNotification={notification => this.removeTarget = notification} />)}
        </div>
        <PaginationComponent class="m-t-20" v-model={this.pagination} total={this.total} />
        <Confirm isActive={isDefined(this.removeTarget)} type="danger" onClose={() => this.removeTarget = null} onConfirm={this.remove}>
          Vous êtes sur le point de supprimer cette notification. Veuillez confirmer la suppression.
        </Confirm>
      </div>
    );
  }
}

@Component
class NotificationListItem extends Vue {
  @Prop({type:Object, required:true}) notification:Notification;
  render(){
    return (
      <div class="notification-list-item" onClick={() => this.$bubble("previewNotification", this.notification)}>
        <div>
          <h3  class="notification-list-item_title">{this.notification.title}</h3>
          <span class="notification-list-item_date">{formatDate(this.notification.publicationDate)}</span>
          { this.notification.type === "flash" && <span class="tag is-smal">Flash</span>}
        </div>
        <button class="button is-small" onClick={(e) => {
          e.stopImmediatePropagation();
          this.$emit("removeNotification", this.notification)
        }}>Supprimer</button>
      </div>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-01a83ac0/notifications-list.tsx" });